module.exports = {"planTypes":{"pre":{"showMore":{"simplified":"Ative aqui sua VeloeTag","complex":"Ative aqui sua VeloeTag"},"yourIdentifier":"Suas VeloeTags","consumption":"Valor consumido"},"pos":{"showMore":{"simplified":"Ver todas as VeloeTags","complex":"Ver todas as VeloeTags"},"yourIdentifier":"Suas VeloeTags","consumption":"Valor consumido"}}}


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/DashboardIdentifierList/data.json
// module id = 1910
// module chunks = 0